import React from 'react';

interface LogoProps {
  className?: string;
  height?: string;
  width?: string;
}

const Logo: React.FC<LogoProps> = ({ className = '', height = '30px', width = '100px' }) => {
  return (
    <div className={`flex items-center ${className}`}>
      <a 
        href="https://www.red5.net" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="flex items-center transition-transform duration-300 hover:scale-105 hover:opacity-90"
      >
        <svg 
          version="1.0" 
          height={height} 
          width={width} 
          id="Layer_1" 
          xmlns="http://www.w3.org/2000/svg" 
          xmlnsXlink="http://www.w3.org/1999/xlink" 
          x="0px" 
          y="0px" 
          viewBox="0 0 83 22" 
          xmlSpace="preserve"
          className="block"
        >
          <style type="text/css">
            {`.st0{fill:#DB1F26;}.st1{fill:#FFFFFF;}`}
          </style>
          <g>
            <g>
              <polygon className="st0" points="12.3,10.9 12.3,6.6 16.8,6.6 16.8,3.8 2,3.8 2,11.6 6.4,11.6 6.4,15.9 2,15.9 2,18.7 16.8,18.7 16.8,10.9"></polygon>
            </g>
          </g>
          <g>
            <path className="st1" d="M27.5,13.3V19h-2.7V4.5h4.4c1,0,1.8,0.1,2.5,0.3c0.7,0.2,1.3,0.5,1.7,0.9C34,6,34.3,6.5,34.5,7
              c0.2,0.5,0.3,1.1,0.3,1.7c0,0.5-0.1,0.9-0.2,1.4s-0.4,0.8-0.6,1.2c-0.3,0.4-0.6,0.7-1,0.9s-0.8,0.5-1.4,0.6
              c0.3,0.2,0.6,0.5,0.9,0.8l3.6,5.3h-2.4c-0.2,0-0.4,0-0.6-0.1c-0.2-0.1-0.3-0.2-0.4-0.4l-3-4.6c-0.1-0.2-0.2-0.3-0.4-0.4
              s-0.3-0.1-0.6-0.1H27.5z M27.5,11.4h1.7c0.5,0,0.9-0.1,1.3-0.2c0.4-0.1,0.7-0.3,0.9-0.5c0.2-0.2,0.4-0.5,0.5-0.8
              c0.1-0.3,0.2-0.6,0.2-1c0-0.7-0.2-1.3-0.7-1.7c-0.5-0.4-1.2-0.6-2.2-0.6h-1.7V11.4z"></path>
            <path className="st1" d="M48.6,4.5v2.1h-6.4v4h5.1v2.1h-5.1v4.1h6.4V19h-9.1V4.5H48.6z"></path>
            <path className="st1" d="M65.3,11.7c0,1.1-0.2,2-0.5,2.9c-0.4,0.9-0.8,1.6-1.5,2.3c-0.6,0.6-1.4,1.1-2.3,1.5c-0.9,0.4-1.9,0.5-3,0.5
              h-5.5V4.5H58c1.1,0,2.1,0.2,3,0.5c0.9,0.4,1.7,0.9,2.3,1.5c0.6,0.6,1.1,1.4,1.5,2.3C65.2,9.7,65.3,10.7,65.3,11.7z M62.6,11.7
              c0-0.8-0.1-1.5-0.3-2.1C62.1,9,61.8,8.4,61.4,8c-0.4-0.4-0.9-0.8-1.4-1S58.7,6.6,58,6.6h-2.8v10.2H58c0.7,0,1.3-0.1,1.9-0.4
              s1-0.6,1.4-1c0.4-0.4,0.7-1,0.9-1.6C62.5,13.2,62.6,12.5,62.6,11.7z"></path>
            <path className="st1" d="M77.5,5.5c0,0.4-0.1,0.6-0.3,0.9c-0.2,0.2-0.6,0.3-1.1,0.3h-4l-0.5,3c0.7-0.1,1.2-0.2,1.8-0.2
              c0.8,0,1.4,0.1,2,0.3c0.6,0.2,1.1,0.5,1.5,0.9c0.4,0.4,0.7,0.9,0.9,1.4c0.2,0.5,0.3,1.1,0.3,1.7c0,0.8-0.1,1.5-0.4,2.1
              c-0.3,0.6-0.6,1.2-1.1,1.6c-0.5,0.5-1,0.8-1.7,1c-0.7,0.2-1.4,0.4-2.1,0.4c-0.5,0-0.9,0-1.3-0.1c-0.4-0.1-0.8-0.2-1.1-0.4
              c-0.4-0.2-0.7-0.3-1-0.5c-0.3-0.2-0.6-0.4-0.8-0.6l0.8-1c0.2-0.2,0.4-0.3,0.6-0.3c0.2,0,0.3,0.1,0.5,0.2c0.2,0.1,0.4,0.2,0.6,0.3
              s0.5,0.2,0.8,0.3c0.3,0.1,0.7,0.2,1.1,0.2c0.5,0,0.9-0.1,1.2-0.2s0.6-0.4,0.9-0.6c0.2-0.3,0.4-0.6,0.5-0.9c0.1-0.4,0.2-0.8,0.2-1.2
              c0-0.8-0.2-1.4-0.7-1.8s-1.1-0.7-2-0.7c-0.7,0-1.4,0.1-2.1,0.4l-1.5-0.4l1.2-7h7.1V5.5z"></path>
          </g>
        </svg>
      </a>
    </div>
  );
};

export default Logo;
